import styled from 'styled-components';

const AccordionItem = styled.div`
  padding: 30px;
`;

export default AccordionItem;
